<div
    class="notification-card"
    (click)="onClick()"
    [ngClass]="{ disabled: card.Readed.state, edpe: !card.Readed.state && card.Type === 'APPE' }"
>
    <div>
        <div class="header">
            <div class="d-flex align-items-center">
                <div>
                    <div class="icon"></div>
                </div>
                <div class="title">
                    {{ card.Title }}
                </div>
            </div>
            <div class="date">{{ card.getNotificationTime() | translate }}</div>
        </div>
        <div class="message">{{ card.Message }}</div>
    </div>
    <div class="label" *ngIf="(activeFilter$ | async) === 'ALL'">
        <span *ngIf="card.Type === 'APPE'; else contractName">{{ "pt.edp.edponline.edpe.name" | translate }}</span>
        <ng-template #contractName>
            {{ card.Contract?.Nickname }}
        </ng-template>
    </div>
</div>
